import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';
import { selectUtilData } from '../../utils/store/utils.selectors';

export const selectAuthState = createFeatureSelector<AuthState>('auth');
export const selectAuthClaims = createSelector(
    selectAuthState,
    (state: AuthState) => state.data.claims
);
export const selectAuthToken = createSelector(
    selectAuthState,
    (state: AuthState) => state.data.jwt
);

export const selectEnabledApplications = createSelector(
    selectUtilData,
    selectAuthClaims,
    (utilData, claims) => {
        const homeApp: string[] = Object.values(utilData.application.idMap)
            .filter(
                (app) =>
                    app.home &&
                    !claims?.enabled_sso_apps.includes(app.access_key)
            )
            .map((app) => app.access_key);

        return homeApp
            .concat(claims?.enabled_sso_apps || [])
            .map((access_key) => ({
                ...utilData.application.idMap[access_key],
                value: access_key
            }))
            .filter(
                /* Cleanup:
                    Only provide valid applications that have data.
                    In some cases enabled_sso_apps provides bad data (empty value),
                    or the app is not actually found in the full application list details.
                */
                (item) =>
                    Object.keys(item).length !== 1 ||
                    !item.hasOwnProperty('value')
            );
    }
);
